import type { BulkUpdateAlertMutation } from '#/graphql/types';
import { bulkUpdateAlert } from '#/graphql/mutations';
import { useMutation, gql } from '@apollo/react-hooks';
import { useCallback } from 'react';

const q = gql(bulkUpdateAlert);

type Response = {
  updatedCount?: number | null;
  status?: number | null;
  errors?: Array<string | null> | null;
};

const useAlertBulkUpdate = () => {
  const [mutation, result] = useMutation<BulkUpdateAlertMutation>(q);

  const bulkUpdateAlert = useCallback(
    async (data: {
      values: any;
      ids?: string[];
      params?: any;
      requirements?: any;
    }): Promise<Response | null | undefined> => {
      const { values, ids, params, requirements } = data;

      const response = await mutation({
        variables: {
          data: {
            values: values ? JSON.stringify(values) : null,
            ids,
            params,
            requirements: requirements ? JSON.stringify(requirements) : null,
          },
        },
      });

      return response.data?.bulkUpdateAlert || undefined;
    },
    [mutation],
  );

  return { bulkUpdateAlert, result };
};

export default useAlertBulkUpdate;
